/**
 * gradientShimmerAnimation
 * 1. Get event.gamma value 
 * 2. Create gradientString
 *    a. -75deg adds a slight slant to gradient. -90deg would be straight up and down
 *    b. First line is left side of gradient
 *        on flat table (gamma) will equal 0%
 *    c. Second line is middle color + 'gamma + 45'
 *        on flat table (gamma + 45) will equal 45%
 *    c. Third line is middle color + 'gamma + 55'
 *        on flat table (gamma + 55) will equal 55%
 *    d. Fourth line is right side color + 'gamma + 100'
 *        on flat table (gamma + 100) will equal 100%
 
 * @param  {event} event.gamma = value represents the motion of the device around the y axis, 
 *                              represented in degrees with values ranging from -90 to 90. 
 *                              This represents a left to right motion of the device.
 */
var gradientShimmer = document.getElementsByClassName('gradient-shimmer');
function gradientShimmerAnimation(event) {
  var gamma = Math.round(event.gamma);
  var gradientString = 'linear-gradient(-75deg, #E31C90 ' + gamma + '%, ' + '#FB72C2 ' + (gamma + 45) + '%, ' + '#FB72C2 ' + (gamma + 55) + '%, ' + '#E10082 ' + (gamma + 100) + '%)';

  for (var i = 0; i < gradientShimmer.length; i++) {
    gradientShimmer[i].style.background = gradientString;
  }
}
window.addEventListener('deviceorientation', gradientShimmerAnimation);